export const UPDATES_LIST = {
  SCHEDULE_STALE_ERROR: 'updates-list-schedule-stale-error',
  DATE_PICKER: 'updates-list-date-picker',
  DIALOG: 'updates-list-dialog',
  DIALOG_CONTENT: 'updates-list-dialog-content',
  POPUP_HEADER: 'updates-list-popup-header',
  TITLE_TEXT: 'updates-list-title-text',
  SEARCH_ICON_BUTTON: 'updates-list-search-icon-button',
  SEARCH_ICON: 'updates-list-search-icon',
  CLOSE_BUTTON: 'updates-list-close-button',
  CLOSE_ICON: 'updates-list-close-icon',
  SEARCH_WRAPPER: 'updates-list-search-wrapper',
  SEARCH_INPUT: 'updates-list-search-input',
  CONTROLS_AND_CONTENT_WRAPPER: 'updates-list-controls-and-content-wrapper',
  TABS: 'updates-list-tabs',
  SCHEDULED_WORK_TAB: 'updates-list-scheduled-work-tab',
  FUTURE_WORK_TAB: 'updates-list-future-work-tab',
  FUTURE_WORK_LOOKAHEAD_SECTION: 'updates-list-future-work-lookahead-section',
  KEYBOARD_SHORTCUTS_PANEL: 'updates-list-keyboard-shortcuts-panel',
  KEYBOARD_SHORTCUTS_TOGGLE: 'updates-list-keyboard-shortcuts-toggle',
  KEYBOARD_SHORTCUTS_BODY: 'updates-list-keyboard-shortcuts-body',
  KEYBOARD_SHORTCUTS_ROW: 'updates-list-keyboard-shortcuts-row',
  KEYBOARD_SHORTCUTS_KEY: 'updates-list-keyboard-shortcuts-key',
  PROGRESS_UPDATE_INSIGHTS_CARD: 'updates-list-progress-update-insights-card',
  PROGRESS_UPDATE_INSIGHTS_ERROR: 'updates-list-progress-update-insights-error',
  PROGRESS_UPDATE_INSIGHTS_OPTION: 'updates-list-progress-update-insights-option',
  PROGRESS_UPDATE_INSIGHTS_OPTION_CHECKBOX: 'updates-list-progress-update-insights-option-checkbox',
  PROGRESS_UPDATE_INSIGHTS_RUN_BUTTON: 'updates-list-progress-update-insights-run-button',
  UPDATES_CONTROLS: 'updates-list-updates-controls',
  DATES_SECTION: 'updates-list-dates-section',
  SORT_MENU_WRAPPER: 'updates-list-sort-menu-wrapper',
  SORT_MENU: 'updates-list-sort-menu',
  FILTER_MENU: 'updates-list-filter-menu',
  NO_UPDATES_MESSAGE: 'updates-list-no-updates-message',
  UPDATES_CONTENT: 'updates-list-updates-content',
  DATE_SECTION: 'updates-list-date-section',
  DATE_DISPLAY: 'updates-list-date-display',
  ENTRY_ROW: 'updates-list-entry-row',
  ENTRY_COLOR_INDICATOR: 'updates-list-entry-color-indicator',
  ENTRY_DETAILS: 'updates-list-entry-details',
  ENTRY_CODE: 'updates-list-entry-code',
  ENTRY_NAME: 'updates-list-entry-name',
  ENTRY_RESOLVE_BUTTON: 'updates-list-entry-resolve-button',
  ENTRY_NUMBER_DIFFERENCE: 'updates-list-entry-number-difference',
  FILTER_MENU_DROPDOWN: 'updates-list-filter-menu-dropdown',
  FILTER_MENU_LABEL: 'updates-list-filter-menu-label',
  FILTER_MENU_SELECT: 'updates-list-filter-menu-select',
  FILTER_MENU_OPTION: 'updates-list-filter-menu-option',
  FILTER_MENU_OPTION_LABEL: 'updates-list-filter-menu-option-label',
  FILTER_MENU_OPTION_SWITCH: 'updates-list-filter-menu-option-switch',
  FILTER_DATE_RANGE_SECTION: 'updates-list-filter-date-range-section',
  FILTER_DATE_RANGE_WRAPPER: 'updates-list-filter-date-range-wrapper',
  FILTER_DATE_FROM_BOX: 'updates-list-filter-date-from-box',
  FILTER_DATE_TO_BOX: 'updates-list-filter-date-to-box',
  FILTER_DATE_FROM_LABEL: 'updates-list-filter-date-from-label',
  FILTER_DATE_TO_LABEL: 'updates-list-filter-date-to-label',
  GET_STARTED_CONTAINER: 'updates-list-get-started-container',
  GET_STARTED_ILLUSTRATION: 'updates-list-get-started-illustration',
  GET_STARTED_TITLE: 'updates-list-get-started-title',
  GET_STARTED_BRIEF: 'updates-list-get-started-brief',
  GET_STARTED_LIST: 'updates-list-get-started-list',
  GET_STARTED_BUTTON: 'updates-list-get-started-button',
  SELECT_DATE_RANGE_CONTAINER: 'updates-list-select-date-range-container',
  SELECT_DATE_RANGE_ILLUSTRATION: 'updates-list-select-date-range-illustration',
  SELECT_DATE_RANGE_TITLE: 'updates-list-select-date-range-title',
  SELECT_DATE_RANGE_BRIEF: 'updates-list-select-date-range-brief',
  SELECT_DATE_RANGE_BUTTON: 'updates-list-select-date-range-button',
  MORE_MENU_ICON_WRAPPER: 'updates-list-more-menu-icon-wrapper',
  MORE_MENU_ICON: 'updates-list-more-menu-icon',
  MORE_MENU_POPOVER: 'updates-list-more-menu-popover',
  MORE_MENU_CONTENT: 'updates-list-more-menu-content',
  MORE_MENU_TITLE_WRAPPER: 'updates-list-more-menu-title-wrapper',
  MORE_MENU_TITLE: 'updates-list-more-menu-title',
  MORE_MENU_SHOW_RESOLVED: 'updates-list-more-menu-show-resolved',
  MORE_MENU_ONLY_FIELD_UPDATES: 'updates-list-more-menu-only-field-updates',
  MORE_MENU_ONLY_ON_TIME_EARLY: 'updates-list-more-menu-only-on-time-early',
  MORE_MENU_SWITCH_WRAPPER: 'updates-list-more-menu-switch-wrapper',
  MORE_MENU_SWITCH: 'updates-list-more-menu-switch',
  MORE_MENU_BRIEF_TEXT: 'updates-list-more-menu-brief-text',
  FILTER_MENU_EXPANDED_TRIGGER: 'updates-list-filter-menu-expanded-trigger',
  FILTER_MENU_EXPANDED_POPOVER: 'updates-list-filter-menu-expanded-popover',
  FILTER_MENU_EXPANDED_VIEW_SECTION: 'updates-list-filter-menu-expanded-view-section',
  FILTER_MENU_EXPANDED_SHOW_UPDATED: 'updates-list-filter-menu-expanded-show-updated',
  FILTER_MENU_EXPANDED_FILTER_SECTION: 'updates-list-filter-menu-expanded-filter-section',
  FILTER_MENU_EXPANDED_ONLY_ON_TIME: 'updates-list-filter-menu-expanded-only-on-time',
  FILTER_MENU_EXPANDED_ONLY_FIELD_UPDATES: 'updates-list-filter-menu-expanded-only-field-updates',
  FILTER_MENU_EXPANDED_CUSTOM_CODES: 'updates-list-filter-menu-expanded-custom-codes',
  FILTER_MENU_EXPANDED_CUSTOM_CODE_VALUES_SUBMENU: 'updates-list-filter-menu-expanded-custom-code-values-submenu',
  FILTER_MENU_EXPANDED_OWNED_BY: 'updates-list-filter-menu-expanded-owned-by',
  FILTER_MENU_EXPANDED_NESTED_SEARCH: 'updates-list-filter-menu-expanded-nested-search',
  FILTER_MENU_EXPANDED_NESTED_ITEM: 'updates-list-filter-menu-expanded-nested-item',
  FILTER_MENU_EXPANDED_ACTIVE_COUNT: 'updates-list-filter-menu-expanded-active-count',
  SORT_MENU_DROPDOWN: 'updates-list-sort-menu-dropdown',
  SORT_MENU_LABEL: 'updates-list-sort-menu-label',
  SORT_MENU_SELECT: 'updates-list-sort-menu-select',
  SORT_MENU_OPTION: 'updates-list-sort-menu-option',
  SORT_MENU_OPTION_TEXT: 'updates-list-sort-menu-option-text',
  SORT_MENU_OPTION_TICK: 'updates-list-sort-menu-option-tick',
  STANDALONE_DATE_RANGE_SECTION: 'updates-list-standalone-date-range-section',
  STANDALONE_DATE_RANGE_TITLE: 'updates-list-standalone-date-range-title',
  STANDALONE_DATE_RANGE_TITLE_ROW: 'updates-list-standalone-date-range-title-row',
  STANDALONE_DATE_RANGE_TITLE_TEXT: 'updates-list-standalone-date-range-title-text',
  STANDALONE_DATE_OPERATOR_ROW: 'updates-list-standalone-date-operator-row',
  STANDALONE_DATE_OPERATOR_SELECT: 'updates-list-standalone-date-operator-select',
  STANDALONE_DATE_OPERATOR_MENU_ITEM: 'updates-list-standalone-date-operator-menu-item',
  STANDALONE_DATE_RANGE_WRAPPER: 'updates-list-standalone-date-range-wrapper',
  STANDALONE_DATE_BOX_FROM: 'updates-list-standalone-date-box-from',
  STANDALONE_DATE_BOX_TO: 'updates-list-standalone-date-box-to',
  STANDALONE_DATE_BOX_SINGLE: 'updates-list-standalone-date-box-single',
  CLEAR_SEARCH: 'updates-list-clear-search',
  OUT_OF_SEQUENCE_WARNING: 'updates-list-out-of-sequence-warning',
  BULK_UPDATES_BANNER: 'updates-list-bulk-updates-banner',
  LIST_END_SCROLL_SPACER: 'virtuoso-list-end-spacer'
} as const;
